module.exports = __webpack_public_path__ + "static/media/flag_quiz_promo.cafdbdb0.png";